import AIPrompt from './AIPrompt';

export default AIPrompt;
